"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _EventSpeaker = _interopRequireDefault(require("../SIAEventOccurrence/EventSpeaker/EventSpeaker"));
var _GoBackButton = _interopRequireDefault(require("../GoBackButton/GoBackButton"));
var _SIACMSContent = _interopRequireDefault(require("../SIACMSContent/SIACMSContent"));
var _EventOccurrenceList = _interopRequireDefault(require("../../EventOccurrenceList/EventOccurrenceList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-event-speaker-container .inapp-content {\n  display: flex;\n  justify-content: center;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 48px; }\n  .sia-event-speaker-container .inapp-content .accordion-content {\n    display: flex;\n    flex-direction: column;\n    max-width: 342px; }\n    .sia-event-speaker-container .inapp-content .accordion-content * {\n      padding-right: 0; }\n  .sia-event-speaker-container .inapp-content .speaker {\n    display: flex;\n    flex-direction: column;\n    max-width: 244px;\n    flex-wrap: wrap;\n    flex-grow: 1; }\n\n.sia-event-speaker-container .more-events {\n  padding-inline: 0px; }\n\n@media (max-width: 66rem) {\n  .sia-event-speaker-container {\n    padding-bottom: 0px; }\n    .sia-event-speaker-container .inapp-content {\n      gap: 48px; }\n      .sia-event-speaker-container .inapp-content .accordion-content {\n        max-width: 296px;\n        padding-left: 16px; }\n      .sia-event-speaker-container .inapp-content .speaker {\n        max-width: 312px; }\n    .sia-event-speaker-container .more-events {\n      padding-inline: 16px; } }\n\n@media (max-width: 42rem) {\n  .sia-event-speaker-container .inapp-content {\n    flex-direction: column-reverse;\n    gap: 0px; }\n    .sia-event-speaker-container .inapp-content .speaker {\n      max-width: 304px;\n      padding-left: 16px;\n      padding-right: 16px; } }\n";
  const fileName = "SIAEventSpeaker_SIAEventSpeaker";
  const element = document.querySelector("style[data-sass-component='SIAEventSpeaker_SIAEventSpeaker']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAEventSpeaker = _ref => {
  let {
    speaker,
    lang,
    history,
    translate,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-event-speaker-container sia-padding-02-bottom"
  }, /*#__PURE__*/_react.default.createElement(_GoBackButton.default, {
    history: history,
    lang: lang
  }), speaker && /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-content"
  }, speaker?.curriculum_vitae && /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion-content"
  }, /*#__PURE__*/_react.default.createElement(_SIACMSContent.default, {
    lang: lang,
    items: speaker?.curriculum_vitae,
    history: history,
    translate: translate,
    getAgenda: '',
    getParagraph: ''
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "speaker"
  }, /*#__PURE__*/_react.default.createElement(_EventSpeaker.default, {
    picture: speaker?.speaker_picture,
    academic_title: speaker?.academic_title,
    firstname: speaker?.firstname,
    lastname: speaker?.lastname,
    diploma_title: speaker?.diploma_title,
    work_function: speaker?.work_function,
    email: speaker?.speaker_email,
    gender: speaker?.gender,
    contact_urls: speaker?.speaker_contact_urls
  }))), speaker?.events && speaker?.events.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "more-events sia-padding-03-top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-06 sia-padding-01-bottom"
  }, translate('cms.speaker.events'), ' ', speaker.academic_title?.[0]?.name, " ", speaker?.firstname, ' ', speaker?.lastname), /*#__PURE__*/_react.default.createElement(_EventOccurrenceList.default, {
    lang: lang,
    translate: translate,
    eventOccurrences: speaker?.events,
    onClick: onClick
  })));
};
var _default = exports.default = SIAEventSpeaker;